<template>
  <div>
    <CRow>
      <CCol cols="12" md="12" lg="12">
        <b-form>
          <b-form-group :label="$store.state.form.syaratDokAdministrasi" label-cols-md="3">
            <Multiselect
              :state="checkIfValid('dokumenId')"
              v-model="$v.data.dokumenId.$model"
              :options="dokumen"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              label="namaKebutuhan"
              track-by="id"
              :placeholder="$store.state.form.pilihDokumenAdministrasiPlaceholder"
            ></Multiselect>
          </b-form-group>

          <b-form-group label-cols-md="3">
            <b-button
              variant="primary"
              @click="simpan()"
              :disabled="busy || !isValid"
            >
              {{ $store.state.form.tambahkan }}
            </b-button>
          </b-form-group>
        </b-form>
      </CCol>
    </CRow>

    <CRow>
      <CCol cols="12" md="12" lg="12">
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol cols="12" md="12" lg="12">
        <b-table
          :items="items"
          :fields="fields"
          stacked="md"
          responsive
          show-empty
          small
          bordered
          striped
          hover
        >
          <template #cell(no)="item">
            {{ item.index + 1 }}
          </template>
          <template #cell(actions)="item">
            <b-button
              variant="danger"
              class="mr-1"
              v-c-tooltip.hover.click="'Hapus Data'"
              @click="deleteItem(item.index)"
            >
              <CIcon name="cil-trash" /> {{ item.actions }}
            </b-button>
          </template>
        </b-table>
      </CCol>
    </CRow>

    <modal-delete-dok />
  </div>
</template>

<script>
import modalDeleteDok from "./modalDeleteDok.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    modalDeleteDok,
  },
  name: "inputTabDokLoker",
  props: ["dokumen"],
  data() {
    return {
      data: {
        dokumenId: "",
      },
      busy: false,
      kebutuhan: {},
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortable: true,
          sortDirection: "desc",
          class: "table-number text-center",
        },
        {
          key: "namaKebutuhan",
          label: "Syarat Dokumen Administrasi",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "actions",
          label: "Actions",
          class: "table-option-1 text-center",
        },
      ],
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      dokumenId: {
        required,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    simpan() {
      let vm = this;
      let list = {};

      list.namaKebutuhan = vm.data.dokumenId.namaKebutuhan;
      list.masterKebutuhanId = vm.data.dokumenId.id;
      if (!this.items.length) {
        vm.items.push(list);
      } else {
        let flag = false;
        for (let i = 0; i < this.items.length; i++) {
          let x = this.items[i];
          if (x.masterKebutuhanId == vm.data.dokumenId.id) {
            flag = true;
          }
        }
        if (!flag) {
          vm.items.push(list);
        }
      }
      vm.kebutuhan.data = vm.items;
      vm.data.kebutuhanId = "";
      vm.$emit("dokumenFromChild", vm.kebutuhan);
    },
    deleteItem(index) {
      this.items.splice(index, 1);
      this.kebutuhan.data = this.items;
      this.$emit("dokumenFromChild", this.kebutuhan);
    },
  },
};
</script>
